import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import {withRouter} from 'react-router-dom';
import qs from 'qs';
import Titulo from '../comum/Titulo';
import {getFiscalEmbarque, getPerfisVendedores} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import AbaItinerario from './AbaItinerario';
import buscarCaixaAberto from '../../actions/fechamento-caixa/usuario/buscarCaixaAberto';
import selecionarDataIda from '../../actions/origem/selecionarDataIda';
import selecionarDestino from '../../actions/destino/selecionarDestino';
import selecionarOrigem from '../../actions/origem/selecionarOrigem';
import selecionarViagem from '../../actions/viagem/selecionarViagemIda';
import AbaSelecionarEMarcarPoltrona from './AbaSelecionarEMarcarPoltrona';
import AbaPassageiro from './AbaPassageiro';
import adicionarPassageirosIda from '../../actions/passageiro/adicionarPassageirosIda'
import adicionarPassageirosVolta from '../../actions/passageiro/adicionarPassageirosVolta';
import AbaDadosComprador from './AbaDadosComprador';
import AbaFormaPagamento from './AbaFormaPagamento';
import AbaResumoCompra from './AbaResumoCompra';
import {cadastrarReserva, pagarPedido} from '../../actions/reserva/actionsReserva'
import {arredondamentoPadrao, realParaNumber} from '../../util/numberUtil';
import remarcarReservas from '../../actions/reserva/remarcarReservas';
import alterarTipoEmissaoPassageiroIda from '../../actions/passageiro/alterarTipoEmissaoPassageiroIda';
import alterarTipoEmissaoPassageiroVolta from '../../actions/passageiro/alterarTipoEmissaoPassageiroVolta';
import selecionarReservasRemarcacao from '../../actions/remarcacao/selecionarReservasRemarcacao';
import {adicionarFormasPagamento} from '../../actions/viagem/adicionarFormasPagamento';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import selecionarDescontoUsuario from '../../actions/desconto/selecionarValorDescontoCalculado';
import buscarTiposDocumento from '../../actions/pessoa/buscarTiposDocumento';
import limpaViagens from '../../actions/viagem/limpaViagens';
import informarVendaEmMassa from '../../actions/viagem/informarVendaEmMassa';
import selecionarUsuario from '../../actions/usuario/selecionarUsuario'
import {alterarReservaParaCriada, alterarSituacaoFormaPagamentoReservaCriada} from '../../actions/reserva/selecionarReservaParaCriar';
import {verificarPagamento} from '../../actions/reserva/actionsReserva';
import {usuarioEmpresaHabilitadoPagamentoViaPOS} from '../../actions/usuario/cadastrarUsuariosEmpresaEmLote';

import {
    TIPOS_EMISSAO_ACOMPANHANTE,
    TIPOS_EMISSAO_CORTESIA,
    TIPOS_EMISSAO_ID_JOVEM_100,
    TIPOS_EMISSAO_IDOSO_100,
    TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR,
    TIPOS_EMISSOES,
    TIPOS_EMISSOES_COM_GRATUIDADE,
} from './TiposEmissoes';
import {showInfoMsg, showSuccessMsg} from '../../util/messagesUtil';
import {renderField} from '../../util/inputs';
import ReactTooltip from 'react-tooltip';
import {showErrorMsg} from '../../util/messagesUtil';
import {verificarItinerarioAtivoOuInativo} from '../../actions/itinerario/verificarItinerarioAtivoOuInativo';
import selecionarAcrescimoPassagemCalculado
    from '../../actions/acrescimo-passagem/selecionarAcrescimoPassagemCalculado';

export class PainelVenderPassagem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            abaSelecionada: 1,
            valorTotalPedido: 0,
            descontoInformado: 0.00,
            acrescimoPassagemInformado: 0.00,
            seFormaPagamentoNaoFoiSelecionado: false,
            vendaSeguroHabilitadaNaEmpresa: false,
            botaoConcluirVendaDisabled: true,
        };
    }

    UNSAFE_componentWillMount() {
        if (this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            this.props.buscarCaixaAberto(this.props.empresaSelecionada.id);
        }
    }

    componentDidMount() {
        const parametros = qs.parse(this.props.history.location.search, {ignoreQueryPrefix: true});
        this.props.buscarTiposDocumento();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.adicionarFormasPagamento([]);
        this.props.usuarioEmpresaHabilitadoPagamentoViaPOS(this.props.empresaSelecionada.id);
        if (!parametros.remarcacao) {
            this.limparTudo()
        }
        this.props.informarVendaEmMassa(false);
        if(this.props.usuariosEmpresa){
            this.setState({botaoConcluirVendaDisabled: this.props.usuariosEmpresa.habilitadoPagamentoViaPOS})
        }
    }

    selecionarDescontoInformado(desconto) {
        this.setState({descontoInformado: desconto})
    }

    selecionarAcrescimoPassagemInformado(acrescimo) {
        this.setState({acrescimoPassagemInformado: acrescimo})
    }

    seExibiAbaFormaPagamentoAvancar() {
        if (this.calcularValorTotal() === 0) {
            this.setState({abaSelecionada: this.state.abaSelecionada + 2})
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada + 1})
        }
    }

    seExibiAbaFormaPagamentoVoltar() {
        if (this.calcularValorTotal() === 0) {
            this.setState({abaSelecionada: this.state.abaSelecionada - 2})
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada - 1})
        }
    }

    avancar() {
        if (this.state.abaSelecionada === 4) {
            this.seExibiAbaFormaPagamentoAvancar()
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada + 1})
        }
    }

    voltar() {
        if (this.props.ehVendaEmMassa) {
            this.setState({abaSelecionada: 2})
        } else if (this.state.abaSelecionada === 6) {
            this.seExibiAbaFormaPagamentoVoltar()
        } else {
            this.setState({abaSelecionada: this.state.abaSelecionada - 1})
        }
    }

    abaSelecionada(aba) {
        if (this.state.abaSelecionada >= aba) {
            return 'nav-link active'
        }
        return 'nav-link'
    }

    tratarAvancarPassageiro() {
        const pass = this.props.passageirosIda.filter(p => !p.nome).length > 0;
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            const passVolta = this.props.passageirosVolta.filter(p => !p.nome).length > 0;
            return !this.props.passageirosIda
                || !this.props.passageirosVolta
                || pass || passVolta
                || this.props.passageirosIda.length === 0
                || this.props.passageirosVolta.length === 0
        }
        return !this.props.passageirosIda || pass || this.props.passageirosIda.length === 0
    }

    gerarCPF() {
        var cpfBase = '';
        for (var i = 0; i < 9; i++) {
            cpfBase += Math.floor(Math.random() * 10);
        }

        var digito1 = this.calcularDigitoVerificador(cpfBase, 10);
        var digito2 = this.calcularDigitoVerificador(cpfBase + digito1, 11);

        return cpfBase + digito1 + digito2;
    }

    calcularDigitoVerificador(base, peso) {
        var soma = 0;
        for (var i = 0; i < base.length; i++) {
            soma += parseInt(base.charAt(i)) * peso--;
        }
        var resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    }

    gerarCPFsUnicos(quantidade) {
        var cpfs = new Set();

        while (cpfs.size < quantidade) {
            var novoCPF = this.gerarCPF();
            cpfs.add(novoCPF);
        }

        return Array.from(cpfs);
    }

    //Só remarcação
    preecherPassageiro() {
        if (this.props.reservasSelecionadasRemarcacao) {
            const idas = [];
            // eslint-disable-next-line array-callback-return
            this.props.reservasSelecionadasRemarcacao.map((reserva, index) => {
                const passageiro = Object.assign({}, reserva.passageiroDto);
                const passIda = this.props.passageirosIda[index];

                if (passIda && passIda.poltronaId !== reserva.poltronaId) {
                    passageiro.poltronaId = passIda.poltronaId;
                    passageiro.numeroPoltrona = passIda.numeroPoltrona;
                    passageiro.sentido = passIda.sentido;
                    passageiro.criancaColo = passageiro.criancaDto !== null;
                    // eslint-disable-next-line prefer-destructuring
                    passageiro.tipoEmissao = TIPOS_EMISSOES.concat(TIPOS_EMISSOES_COM_GRATUIDADE)
                        .filter(f => f.value === passageiro.tipoEmissao)[0].value;
                    passageiro.valor = passIda.valor;
                    passageiro.taxaEmbarque = this.props.viagemIda.taxaEmbarque;
                    idas.push(passageiro)
                }
            });
            this.props.adicionarPassageirosIda(idas)
        }
    }

    preecherPassageiroCadastroEmMassa() {
        this.props.informarVendaEmMassa(true);
        if (this.props.passageirosIda || this.props.passageirosVolta) {
            const idas = [];
            const voltas = [];
            if (this.props.passageirosIda) {
                const cpfValidos = this.gerarCPFsUnicos(this.props.passageirosIda.length);
                this.props.passageirosIda.map(passageiro => {
                    const novoPassageiro = {
                        nome: 'Cadastro em massa ' + passageiro.numeroPoltrona,
                        criancaColo: null,
                        cpfPassageiro: cpfValidos.pop(),
                        documentoComFoto: '12345',
                        dtNascimento: '',
                        numeroPoltrona: passageiro.numeroPoltrona,
                        poltronaId: passageiro.poltronaId,
                        valor: passageiro.valor,
                        sentido: 'IDA',
                        criancaDto: null,

                        tipoEmissao: 'NORMAL',
                        nis: '',
                        validade: '',
                        dtNascimetoIdoso: '',
                        renda: 0.00,
                        cargoProfissao: '',
                        numeroDeficiente: '',
                        opcaoDescontoMeia: '',
                        telefone: '',
                        matricula: '',
                        taxaEmbarque: 0.00,
                        tipoDocumento: 'RG',
                        ddi: 32
                    };
                    idas.push(novoPassageiro)
                });
                this.props.adicionarPassageirosIda(idas);
            }

            if (this.props.passageirosVolta) {
                const cpfValidos = this.gerarCPFsUnicos(this.props.passageirosVolta.length);
                this.props.passageirosVolta.map(passageiro => {
                    const novoPassageiro = {
                        nome: 'Cadastro em massa ' + passageiro.numeroPoltrona,
                        criancaColo: null,
                        cpfPassageiro: cpfValidos.pop(),
                        documentoComFoto: '12345',
                        dtNascimento: '',
                        numeroPoltrona: passageiro.numeroPoltrona,
                        poltronaId: passageiro.poltronaId,
                        valor: passageiro.valor,
                        sentido: 'VOLTA',
                        criancaDto: null,
                        tipoEmissao: 'NORMAL',
                        nis: '',
                        validade: '',
                        dtNascimetoIdoso: '',
                        renda: 0.00,
                        cargoProfissao: '',
                        numeroDeficiente: '',
                        opcaoDescontoMeia: '',
                        telefone: '',
                        matricula: '',
                        taxaEmbarque: 0.00,
                        tipoDocumento: 'RG',
                        ddi:32
                    };
                    voltas.push(novoPassageiro)
                });
                this.props.adicionarPassageirosVolta(voltas);
            }


            const comprador = {
                cpfComprador: '123.456.789-09',
                nomeComprador: 'Venda em massa',
                telefoneComprador: '',
                ddiComprador: 32
            };
            this.props.adicionarDadosComprador(comprador);

            const pagamentos = [];
            const valorTotalReserva = this.calcularValorTotal();
            pagamentos.push({
                tipo: 'Dinheiro',
                codigoTipo: 'DINHEIRO',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: valorTotalReserva,
                quantidadeParcelas: 1,
                descontoIda: null,
                descontoVolta: null,
                acrescimoPassagemIda: null,
                acrescimoPassagemVolta: null,
            });
            this.props.adicionarFormasPagamento(pagamentos);
        }
        this.setState({abaSelecionada: 6});
        this.abaSelecionada(6)

    }

    preencherFormaPagamento() {
        const pagamentos = [];
        if (this.props.cartaoCredito) {
            pagamentos.push({
                tipo: 'Cartão de Crédito',
                codigoTipo: 'CARTAO_CREDITO',
                base64Comprovante: this.props.base64Comprovante,
                numeroComprovante: this.props.numeroComprovante,
                valor: realParaNumber(this.props.valorCartaoCredito),
                quantidadeParcelas: Number(this.props.quantidadeParcelas),
                nomeComprovante: this.props.nomeComprovanteVenda,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PENDENTE',
                habilitado: true,
            })
        }

        if (this.props.cartaoDebito) {
            pagamentos.push({
                tipo: 'Cartão de Débito',
                codigoTipo: 'CARTAO_DEBITO',
                base64Comprovante: this.props.base64Comprovante,
                numeroComprovante: this.props.numeroComprovante,
                valor: realParaNumber(this.props.valorCartaoDebito),
                quantidadeParcelas: Number(this.props.quantidadeParcelas),
                nomeComprovante: this.props.nomeComprovanteVenda,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'PEDENTE',
                habilitado: true,
            })
        }

        if (this.props.dinheiro) {
            pagamentos.push({
                tipo: 'Dinheiro',
                codigoTipo: 'DINHEIRO',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorDinheiro),
                quantidadeParcelas: 1,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'APROVADO',
                habilitado: false,
            })
        }

        if (this.props.pix) {
            pagamentos.push({
                tipo: 'PIX',
                codigoTipo: 'PIX',
                base64Comprovante: this.props.base64ComprovantePIX,
                numeroComprovante: this.props.numeroComprovantePIX,
                valor: realParaNumber(this.props.valorPIX),
                quantidadeParcelas: 1,
                nomeComprovante: this.props.nomeComprovanteVendaPIX,
                descontoIda: this.props.descontoIda,
                descontoVolta: this.props.descontoVolta,
                acrescimoPassagemIda: this.props.acrescimoPassagemIda,
                acrescimoPassagemVolta: this.props.acrescimoPassagemVolta,
                situacao: 'APROVADO',
                habilitado: false,
            })
        }

        this.props.adicionarFormasPagamento(pagamentos);
    }

    verificarSeFormaPagamentoNaoFoiSelecionado(dinheiro, cartaoCredito, cartaoDebito, pix) {        
        if (cartaoCredito == undefined) cartaoCredito = false;
        if (cartaoDebito == undefined) cartaoDebito = false;        
        this.setState({seFormaPagamentoNaoFoiSelecionado: dinheiro == false && cartaoCredito == false && pix == false && cartaoDebito == false});
    }

    somarValorFormaPagamento() {
        let valorTotalFormaPagamento = 0;
        // eslint-disable-next-line no-return-assign
        this.props.formasPagamento.forEach(fp => valorTotalFormaPagamento += Number(fp.valor));
        return arredondamentoPadrao(valorTotalFormaPagamento);
    }

    tratarAvancarPagamento() {
        if (this.state.seFormaPagamentoNaoFoiSelecionado) return true;

        this.preencherFormaPagamento();
        const {
            submitting, invalid, pristine,
        } = this.props;

        return (submitting || invalid || pristine)
            && (!this.props.formasPagamento
                || (!this.props.formasPagamento && this.calcularValorTotal() === 0)
                || (this.somarValorFormaPagamento() !== this.calcularValorTotal()))
    }

    tratarBotaoAvancar() {
        switch (this.state.abaSelecionada) {
            case 1: {
                return !this.props.viagemIda
            }
            case 2: {
                if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
                    return this.props.passageirosIda.length + this.props.passageirosVolta.length !== this.props.reservasSelecionadasRemarcacao.length
                }
                return this.props.passageirosIda === null || this.props.passageirosIda.length === 0
            }
            case 3: {
                let idItinerario = this.props.viagemIda ? this.props.viagemIda.idItinerario : 0;
                idItinerario = idItinerario === 0 && this.props.viagemVolta ? this.props.viagemVolta.idItinerario : 0
                this.props.verificarItinerarioAtivoOuInativo(idItinerario)
                    .then((resp) => {
                        if (resp.payload.status === 200 && resp.payload.data === true && !(this.props.bloqueioPoltronasTemporario.bloqueios.length > 0)) {
                            showErrorMsg('O itinerário está inativo!');
                            this.props.limparTudo();
                        }
                    });
                return this.tratarAvancarPassageiro()
            }
            case 4: {
                return !this.props.dadosPagamento
            }
            case 5: {
                return this.tratarAvancarPagamento()
            }
            default: {
                return false;
            }
        }
    }

    alterarTipoEmissaoPassageiroIda() {
        if (this.props.reservasSelecionadasRemarcacao && this.props.reservasSelecionadasRemarcacao.length > 0) {
            this.props.alterarTipoEmissaoPassageiroIda();
            this.props.alterarTipoEmissaoPassageiroVolta()
        }
    }

    exibirBotoesRodape() {
        return (<div className="card-footer bg-white text-center">

            {this.state.abaSelecionada > 1 && this.state.abaSelecionada !== 7 ? <button onClick={() => this.voltar()}
                                                                                        className='btn btn-sm btn-laranja float-left'>Voltar</button> : ''}

            {this.state.abaSelecionada < 6 && this.state.abaSelecionada !== 2 && this.state.abaSelecionada !== 4
                ? <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
                    <button onClick={() => this.avancar()}
                            className='btn btn-sm btn-laranja float-right'
                            disabled={this.tratarBotaoAvancar()}>

                        Avançar
                    </button>
                </Autorizacao> : ''}

            {this.state.abaSelecionada === 2
                ? <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
                    <button onClick={() => {
                        this.avancar();
                        this.preecherPassageiro()
                    }}
                            className='btn btn-sm btn-laranja float-right'
                            disabled={this.tratarBotaoAvancar()}>

                        Avançar
                    </button>
                </Autorizacao> : ''
            }
            {this.state.abaSelecionada === 2
                ? <Autorizacao perfisPermitidos={[getFiscalEmbarque(this.props.empresaSelecionada.id)]}>
                    <button onClick={() => {
                        this.avancar();
                        this.preecherPassageiroCadastroEmMassa()
                    }}
                            className='btn btn-sm btn-laranja center'
                            disabled={this.tratarBotaoAvancar()}>

                        Cadastrar em massa
                    </button>
                </Autorizacao> : ''
            }
            {this.state.abaSelecionada === 4
                ? <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}>
                    <button onClick={() => {
                        this.avancar();
                        this.alterarTipoEmissaoPassageiroIda()
                    }}
                            className='btn btn-sm btn-laranja float-right'
                            disabled={this.tratarBotaoAvancar()}>

                        Avançar
                    </button>
                </Autorizacao> : ''
            }


            {this.state.abaSelecionada === 6 ?
                <button onClick={() => this.criarReserva()}
                    className='btn btn-sm btn-laranja float-right'
                    disabled={this.props.usuariosEmpresa.habilitadoPagamentoViaPOS}>Concluir  venda
                </button>
            : ''
            }

        </div>)
    }

    limparTudo() {
        this.setState({abaSelecionada: 1});
        this.props.limpaViagens();
        this.props.adicionarPassageirosIda([]);
        this.props.adicionarPassageirosVolta([]);
        this.props.selecionarReservasRemarcacao(null);
        this.props.adicionarFormasPagamento(null);
        this.props.selecionarUsuario(null)
        this.props.selecionarDescontoUsuario({
            ida: 0.00,
            volta: 0.00,
        })
        this.props.selecionarAcrescimoPassagemCalculado({
            ida: 0.00,
            volta: 0.00,
        })
    }

    criarReserva() {
        if (this.props.reservasSelecionadasRemarcacao) {            
            this.props.remarcarReservas(this.props.criarReserva, this.props.reservasSelecionadasRemarcacao.length > 0)
                .then((resp) => {
                    showSuccessMsg('Reserva remarcada com sucesso');
                    this.limparTudo();
                    this.props.history.push(`/recibo-passagem?pedido=${resp.payload.data}`)
                })
        } else {            
            this.props.cadastrarReserva(this.props.criarReserva)
                .then((resp) => {
                    showSuccessMsg('Reserva cadastrada com sucesso');
                    this.props.history.push(`/recibo-passagem?pedido=${resp.payload.data}`);
                    this.limparTudo();
                })
        }
    }

    incluirIdPedido(idPedido){
        this.props.alterarReservaParaCriada(idPedido)
    }

    verificarSeFormaPagamentoAprovadas() {
        const todasAprovadas = this.props.criarReserva.formasPagamentoDto.every(forma => forma.situacao === 'APROVADO');
        if (todasAprovadas) {
            this.props.history.push(`/recibo-passagem?pedido=${this.props.criarReserva.pedidoId}`);
            this.limparTudo();
        }
    }

    verificarPagamento(formaPagamento) {
        this.props.verificarPagamento(this.props.criarReserva.pedidoId, formaPagamento.codigoTipo).then((resp) => {
            if (resp.payload.data === 'APROVADO') {
                clearInterval(this.pollingInterval);
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'APROVADO', false);
                this.verificarSeFormaPagamentoAprovadas();
            }
            if (resp.payload.data === 'CANCELADO') {
                clearInterval(this.pollingInterval);
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'CANCELADO', true);
            }
            if (resp.payload.data === 'PENDENTE') {
                clearInterval(this.pollingInterval);
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'PENDENTE', true);
            }
            if (resp.payload.data === 'AGUARDANDO_CONFIRMACAO') {
                showInfoMsg('Aguardando confirmação de pagamento')
            }
        })
    }

    pagarPedido(formaPagamento) {
        this.props.pagarPedido(this.props.criarReserva)
            .then((resp) => {
                showSuccessMsg('Solicitação de pagamento enviada!! Por favor aguarde..');
                this.incluirIdPedido(resp.payload.data);
                this.pollingInterval = setInterval(() => this.verificarPagamento(formaPagamento), 15000);
            })
            .catch((error) => {
                showErrorMsg('Ocorreu um erro ao processar o pagamento. Por favor, tente novamente.');
                console.error('Erro ao processar o pagamento:', error);
                clearInterval(this.pollingInterval);
                this.props.alterarSituacaoFormaPagamentoReservaCriada(formaPagamento, 'PENDENTE', true);
            });
    }

    habilitarVendaSeguro(check) {
        this.setState({vendaSeguroHabilitadaNaEmpresa: check})
    }

    exibirAbaSelecionada() {
        switch (this.state.abaSelecionada) {
            case 1: {
                return (<AbaItinerario/>)
            }

            case 2: {
                return (<AbaSelecionarEMarcarPoltrona limparTudo={this.limparTudo.bind(this)}/>)
            }
            case 3: {
                return (<AbaPassageiro calcularValorTotal={this.calcularValorTotal.bind(this)}
                                       calcularValorTotalTaxa={this.calcularValorTotalTaxa.bind(this)}
                                       ehGratuidadeTotal={this.ehGratuidadeTotal.bind(this)}
                                       ehIdoso100={this.ehIdoso100.bind(this)}
                                       ehDeficiente={this.ehDeficiente.bind(this)}
                                       ehAcompanhante={this.ehAcompanhante.bind(this)}
                                       ehCortesia={this.ehCortesia.bind(this)}
                                       ehIdJovem100={this.ehIdJovem100.bind(this)}
                                       ehMeiaPassagem={this.ehMeiaPassagem.bind(this)}
                                       ehIdJovem50={this.ehIdJovem50.bind(this)}
                                       ehIdoso50={this.ehIdJovem50.bind(this)}
                                       habilitarVendaSeguro={this.habilitarVendaSeguro.bind(this)}
                                       vendaSeguroHabilitadaNaEmpresa={this.state.vendaSeguroHabilitadaNaEmpresa}/>)
            }
            case 4: {
                return (<AbaDadosComprador/>)
            }
            case 5: {
                return (<AbaFormaPagamento
                    calcularValorTotal={this.calcularValorTotal.bind(this)}
                    calcularValorTotalSemTarifaSeguro={this.calcularValorTotalSemTarifaSeguro.bind(this)}
                    selecionarDescontoInformado={this.selecionarDescontoInformado.bind(this)}
                    selecionarAcrescimoPassagemInformado={this.selecionarAcrescimoPassagemInformado.bind(this)}
                    verificarSeFormaPagamentoNaoFoiSelecionado={this.verificarSeFormaPagamentoNaoFoiSelecionado.bind(this)}
                />)
            }
            case 6: {
                return (<AbaResumoCompra calcularValorTotal={this.calcularValorTotal.bind(this)}
                                         pagarPedido = {this.pagarPedido.bind(this)}
                                         descontoInformado={this.state.descontoInformado}
                                         ehGratuidadeTotal={this.ehGratuidadeTotal.bind(this)}/>)
            }

            default: {
                return '';
            }
        }
    }

    verificaTipoEmissao(tipo) {
        if (tipo && tipo.value === undefined) {
            return TIPOS_EMISSOES
                .concat(TIPOS_EMISSOES_COM_GRATUIDADE)
                .concat(TIPOS_EMISSAO_ACOMPANHANTE)
                .concat(TIPOS_EMISSAO_ID_JOVEM_100)
                .concat(TIPOS_EMISSAO_CORTESIA)
                .concat(TIPOS_EMISSAO_IDOSO_100)
                .concat(TIPOS_EMISSAO_P_LIVRE_POLICIAL_AUDITOR)
                .filter(f => f.value === tipo)[0]
        }
        return tipo
    }

    ehMeiaPassagem(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ID_JOVEM_50'
            || emissao.value === 'IDOSO_50'
    }

    ehGratuidadeTotal(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return this.ehIdJovem100(tipoEmissao)
            || this.ehIdoso100(tipoEmissao)
            || this.ehDeficiente(tipoEmissao)
            || this.ehCortesia(tipoEmissao)
            || emissao.value === 'P_LIVRE_POLICIAL_AUDITOR'
            || this.ehAcompanhante(tipoEmissao)
    }

    ehIdoso100(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'IDOSO_100'
    }

    ehDeficiente(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'DEFICIENTE'
    }

    ehAcompanhante(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ACOMPANHANTE'
    }

    ehCortesia(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'CORTESIA'
    }

    ehIdJovem100(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ID_JOVEM_100'
    }

    ehIdJovem50(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'ID_JOVEM_50'
    }

    ehIdoso50(tipoEmissao) {
        const emissao = this.verificaTipoEmissao(tipoEmissao);
        if (emissao === undefined || emissao.value === undefined) return false;
        return emissao.value === 'IDOSO_50'
    }

    calcularValorPassageiro(pass, viagem) {
        const garantiaPreco = this.props.bloqueioPoltronasTemporario.bloqueios.filter(b => b.poltronaId === pass.poltronaId)[0];
        const alteradoViagem = Object.assign({}, viagem, {
            precoMeia: garantiaPreco.precoMeia,
            precoANTTMeia: garantiaPreco.precoANTTMeia,
        });
        const alteradoPass = Object.assign({}, pass, {valor: viagem.usuarioEhHabilitadoVenderValorANTT ? garantiaPreco.precoANTT : garantiaPreco.preco});

        if (this.ehMeiaPassagem(pass.tipoEmissao)) {
            if (pass.opcaoDescontoMeia === 'EMPRESA') {
                return Number(alteradoViagem.precoMeia)
            }
            return Number(alteradoViagem.precoANTTMeia)
        }
        if (this.ehGratuidadeTotal(pass.tipoEmissao)) {
            return 0.00
        }
        return alteradoPass.valor
    }

    calcularValorTotalTaxa() {
        return this.calcularValorTotalTaxaEmbarque() + this.calcularValorTotalEmPedagio()
    }

    calcularValorTotalTaxaEmbarque() {
        let valorTotalTaxa = 0.00;
        if (this.props.passageirosIda && this.props.passageirosIda.length > 0) {
            this.props.passageirosIda.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemIda.taxaEmbarque)
                }
            })
        }
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            this.props.passageirosVolta.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemVolta.taxaEmbarque)
                }
            })
        }
        return valorTotalTaxa;
    }

    calcularValorTotalEmPedagio() {
        let valorTotalPedagio = 0.00;
        if (this.props.passageirosIda && this.props.passageirosIda.length > 0) {
            this.props.passageirosIda.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalPedagio += Number(this.props.viagemIda.pedagio)
                }
            })
        }
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            this.props.passageirosVolta.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalPedagio += Number(this.props.viagemVolta.pedagio)
                }
            })
        }
        return valorTotalPedagio;
    }

    calcularValorTotalSeguro() {
        let valorTotalSeguro = 0.00;
        if (this.props.passageirosIda && this.props.passageirosIda.length > 0) {
            this.props.passageirosIda.forEach((pass) => {
                if (pass.vendaSeguro && !this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalSeguro += Number(this.props.viagemIda.tarifaSeguro)
                }
            })
        }
        if (this.props.passageirosVolta && this.props.passageirosVolta.length > 0) {
            this.props.passageirosVolta.forEach((pass) => {
                if (pass.vendaSeguro && !this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalSeguro += Number(this.props.viagemVolta.tarifaSeguro)
                }
            })
        }
        return valorTotalSeguro;
    }


    calcularValorTotalSemTaxa() {
        return this.calcularValorTotal() - this.calcularValorTotalTaxaEmbarque() - this.calcularValorTotalEmPedagio() - this.calcularValorTotalSeguro()
    }

    calcularValorTotalSemTarifaSeguro() {
        return this.calcularValorTotal() - this.calcularValorTotalSeguro()
    }


    calcularValorTotal() {
        let valorIda = 0.00;
        let valorVolta = 0.00;
        let valorTotalTaxa = 0.00;
        let valorTotalPedagio = 0.00;
        if (this.existePassagens(this.props.passageirosIda)) {
            this.props.passageirosIda.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemIda.taxaEmbarque)
                    valorTotalPedagio += Number(this.props.viagemIda.pedagio)

                }
                const valor = this.calcularValorPassageiro(pass, this.props.viagemIda);
                if (valor) {
                    valorIda += Number(valor)
                }
            })
        }

        if (this.existePassagens(this.props.passageirosVolta)) {
            this.props.passageirosVolta.forEach((pass) => {
                if (!this.ehGratuidadeTotal(pass.tipoEmissao)) {
                    valorTotalTaxa += Number(this.props.viagemVolta.taxaEmbarque)
                    valorTotalPedagio += Number(this.props.viagemVolta.pedagio)

                }
                const valor = this.calcularValorPassageiro(pass, this.props.viagemVolta);
                if (valor) {
                    valorVolta += Number(valor)
                }
            })
        }
        const creditoRemarcacao = this.calcularValorTotalCreditoRemarcacao();
        if (creditoRemarcacao > 0) {
            const taxaRemarcacao = this.calcularValorTaxaRemarcacao();
            let valorAPagar = (Number(valorIda + valorVolta + valorTotalTaxa + valorTotalPedagio + this.calcularValorTotalSeguro()) - creditoRemarcacao);
            if (valorAPagar > 0) {
                valorAPagar += Number(taxaRemarcacao);
                return Number(arredondamentoPadrao(valorAPagar))
            }
            return Number(taxaRemarcacao)
        }
        const somatorioTotal = valorIda + valorVolta + valorTotalTaxa + valorTotalPedagio + this.calcularValorTotalSeguro();
        if (this.props.valorDescontoUsuarioCalculado.ida > 0 || this.props.valorDescontoUsuarioCalculado.volta > 0) {
            let valorDesconto = 0.00;
            if (this.props.valorDescontoUsuarioCalculado.ida) {
                valorDesconto += Number(this.props.valorDescontoUsuarioCalculado.ida)

            }
            if (this.props.valorDescontoUsuarioCalculado.volta) {
                valorDesconto += Number(this.props.valorDescontoUsuarioCalculado.volta)

            }

            return Number(arredondamentoPadrao(somatorioTotal - valorDesconto))
        }

        if (this.props.valorAcrescimoPassagemCalculado.ida > 0 || this.props.valorAcrescimoPassagemCalculado.volta > 0) {
            let valorAcrescimo = 0.00;
            if (this.props.valorAcrescimoPassagemCalculado.ida) {
                valorAcrescimo += Number(this.props.valorAcrescimoPassagemCalculado.ida)

            }
            if (this.props.valorAcrescimoPassagemCalculado.volta) {
                valorAcrescimo += Number(this.props.valorAcrescimoPassagemCalculado.volta)

            }

            return Number(arredondamentoPadrao(somatorioTotal + valorAcrescimo))
        }


        return Number(arredondamentoPadrao(somatorioTotal))
    }

    existePassagens(pasageiros) {
        return pasageiros && pasageiros.length > 0;
    }

    calcularValorTotalSeguroRemarcacao() {
        let valorTotal = 0.00;
        if (this.props.reservasSelecionadasRemarcacao) {
            // eslint-disable-next-line no-return-assign
            this.props.reservasSelecionadasRemarcacao.forEach(reserva => valorTotal += Number(reserva.tarifaSeguro))
        }
        return arredondamentoPadrao(valorTotal)
    }


    calcularValorTaxaRemarcacao() {
        let valorTotal = 0.00;
        if (this.props.reservasSelecionadasRemarcacao) {
            // eslint-disable-next-line no-return-assign
            this.props.reservasSelecionadasRemarcacao.forEach(reserva => valorTotal += Number(reserva.valorTaxaRemarcacao))
        }
        return arredondamentoPadrao(valorTotal)
    }


    calcularValorTotalCreditoRemarcacao() {
        let valorTotal = 0.00;
        if (this.props.reservasSelecionadasRemarcacao) {
            // eslint-disable-next-line no-return-assign
            this.props.reservasSelecionadasRemarcacao.forEach(reserva => valorTotal += Number(reserva.valorTotalReserva))
        }
        return arredondamentoPadrao(valorTotal)
    }

    exibirIconeTaxaEmbarqueEPedagio() {
        return <span className="align-self-center tooltip-info">
            <a data-tip data-for='taxa-embarque-pedagio'>
                <i className="material-icons ajuda-icon" style={{color: '#000'}}>&#xe263;</i>
            </a>
            <div className="tooltip-ut">
                <ReactTooltip className="tooltip-ut" id='taxa-embarque-pedagio'
                              type="dark" effect="solid">
                    <div className="row">Taxa de embarque: {this.calcularValorTotalTaxaEmbarque()
                        .toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}<br/> Total de pedágio: {this.calcularValorTotalEmPedagio().toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                    })}</div>
                </ReactTooltip>
            </div>
        </span>
    }

    exibirTotalizadores() {
        if (this.state.abaSelecionada > 1) {
            if (this.props.reservasSelecionadasRemarcacao) {
                return (
                    <div className="form-row ml-2">
                        <div className="col-md-3 col-sm-3">
                            <strong className='row float-left'><h5>Crédito remarcação: </h5><h5 className='ml-2'
                                                                                                style={{color: '#fa8d42'}}>
                                {this.calcularValorTotalCreditoRemarcacao()
                                    .toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}</h5>
                            </strong>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <strong className='row float-left'><h5>Valor em taxa: </h5><h5 style={{color: '#fa8d42'}}>
                                {this.calcularValorTotalTaxa()
                                    .toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}</h5>
                            </strong>
                            {this.exibirIconeTaxaEmbarqueEPedagio()}
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <strong className='row float-left'><h5>Valor remarcação: </h5><h5
                                style={{color: '#fa8d42'}}>
                                {this.calcularValorTaxaRemarcacao()
                                    .toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}</h5>
                            </strong>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <strong className='row'><h5>Seguro: </h5><h5
                                style={{color: '#fa8d42'}}>
                                {this.calcularValorTotalSeguro()
                                    .toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}</h5>
                            </strong>
                        </div>
                        <div className="col-md-3 col-sm-3">
                            <strong className='row float-left'><h5>Valor à pagar: </h5><h5 className='ml-2'
                                                                                           style={{color: '#fa8d42'}}>
                                {this.calcularValorTotal()
                                    .toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}</h5>
                            </strong>
                        </div>
                    </div>
                )
            }
            return (
                <div className="form-row ml-2">
                    <div className="col-md-3 col-sm-3">
                        <strong className='row float-left'><h5>Total em passagem: </h5><h5 className='ml-2'
                                                                                           style={{color: '#fa8d42'}}>
                            {this.calcularValorTotalSemTaxa()
                                .toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })}</h5>
                        </strong>
                    </div>
                    <div className="col-md-3 col-sm-3">
                        <strong className='row'><h5>Total em taxa: </h5><h5
                            style={{color: '#fa8d42'}}>
                            {this.calcularValorTotalTaxa()
                                .toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })}</h5>
                            {this.exibirIconeTaxaEmbarqueEPedagio()}
                        </strong>

                    </div>
                    <div className="col-md-3 col-sm-3">
                        <strong className='row'><h5>Seguro: </h5><h5
                            style={{color: '#fa8d42'}}>
                            {this.calcularValorTotalSeguro()
                                .toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })}</h5>
                        </strong>
                    </div>

                    <div className="col-md-3 col-sm-3">
                        <strong className='row float-left'><h5>Total geral: </h5>
                            <h5 className='ml-2'
                                style={{color: '#fa8d42'}}>
                                {this.calcularValorTotal()
                                    .toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    })}</h5>
                        </strong>
                    </div>
                </div>

            )
        }
        return ''
    }

    exibir() {
        if (this.props.caixaAberto) {
            return (<div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                <ul id='tabEncomenda' className="nav nav-pills nav-fill">
                    <li className="nav-item">
                        <a className={this.abaSelecionada(1)}><strong>Itinerário</strong></a>
                    </li>
                    <li className="nav-item">
                        <a className={this.abaSelecionada(2)}><strong>Selecionar Poltronas</strong></a>
                    </li>
                    <li className="nav-item">
                        <a className={this.abaSelecionada(3)}><strong>Passageiro</strong></a>
                    </li>
                    <li className="nav-item">
                        <a className={this.abaSelecionada(4)}><strong>Comprador</strong></a>
                    </li>
                    <li className="nav-item">
                        <a className={this.abaSelecionada(5)}><strong>Pagamento</strong></a>
                    </li>
                    <li className="nav-item">
                        <a className={this.abaSelecionada(6)}><strong>Resumo</strong></a>
                    </li>
                </ul>
                <div className='card border-0'>
                    <div className='card-body'>
                        {this.exibirTotalizadores()}
                        {this.exibirAbaSelecionada()}
                    </div>
                    {this.exibirBotoesRodape()}
                </div>
            </div>)
        }
        return <div className='col-12'>
            <div className="mt-2 alert alert-warning text-center" role="alert">
                Seu caixa está em análise de fechamento. Para efetuar mais vendas contate seu gerente.
            </div>
        </div>;
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[...getPerfisVendedores(this.props.empresaSelecionada.id)]}
                         empresaSelecionada={this.props.empresaSelecionada}>
                <div>
                    <div className="row internas">
                        {this.props.reservasSelecionadasRemarcacao
                            ? <Titulo texto="Remarcar reserva" urlRetorno="/painel-pesquisa"/>
                            : <Titulo texto="Nova reserva" urlRetorno="/painel-pesquisa"/>
                        }

                        {this.exibir()}
                    </div>
                    <Field name="vendaEmMassa" type="hidden" component={renderField} css="form-control col-md-12"/>
                </div>
            </Autorizacao>)
    }
}

const selector = formValueSelector('formReserva');

export const mapStateToProps = state => (
    {
        passageirosIda: state.passageirosIda,
        usuariosEmpresa: state.usuariosEmpresa,
        passageirosVolta: state.passageirosVolta,
        formasPagamento: state.formasPagamento,
        dadosPagamento: state.dadosPagamento,
        viagemIda: state.viagemIda,
        viagemVolta: state.viagemVolta,
        poltronasSelecionadas: state.poltronasSelecionadas,
        pedidos: state.pedidos.pedidos,
        empresaSelecionada: state.empresaSelecionada,
        criarReserva: state.criarReserva,
        changeFieldValue,
        filtrosAdicionados: state.filtrosAdicionadosPedido,
        caixaAberto: state.caixaAberto,
        viagens: state.viagens,
        origem: state.origem,
        destino: state.destino,
        reservasSelecionadasRemarcacao: state.remarcacao.reservasSelecionadas,
        passagueiroSelecionado: state.passageiro,
        tiposEmissoesSelecionados: state.tiposEmissoesSelecionados,
        valorDescontoUsuarioCalculado: state.valorDescontoUsuarioCalculado,
        ehVendaEmMassa: state.ehVendaEmMassa,
        bloqueioPoltronasTemporario: state.bloqueioPoltronasTemporario,
        cartao: selector(state, 'cartao'),
        cartaoCredito: selector(state, 'cartaoCredito'),
        cartaoDebito: selector(state, 'cartaoDebito'),
        valorCartao: selector(state, 'valorCartao'),
        valorCartaoCredito: selector(state, 'valorCartaoCredito'),
        valorCartaoDebito: selector(state, 'valorCartaoDebito'),
        dinheiro: selector(state, 'dinheiro'),
        valorDinheiro: selector(state, 'valorDinheiro'),
        pix: selector(state, 'pix'),
        valorPIX: selector(state, 'valorPIX'),
        nomeComprovanteVenda: selector(state, 'nomeComprovanteVenda'),
        numeroComprovante: selector(state, 'numeroComprovante'),
        base64Comprovante: selector(state, 'base64Comprovante'),
        nomeComprovanteVendaPIX: selector(state, 'nomeComprovanteVendaPIX'),
        numeroComprovantePIX: selector(state, 'numeroComprovantePIX'),
        base64ComprovantePIX: selector(state, 'base64ComprovantePIX'),
        descontoIda: selector(state, 'descontoIda'),
        descontoVolta: selector(state, 'descontoVolta'),
        quantidadeParcelas: selector(state, 'quantidadeParcelas'),
        valorAcrescimoPassagemCalculado: state.valorAcrescimoPassagemCalculado,
        acrescimoPassagemIda: selector(state, 'acrescimoPassagemIda'),
        acrescimoPassagemVolta: selector(state, 'acrescimoPassagemVolta'),

    });

export default withRouter(connect(mapStateToProps,
    {
        buscarCaixaAberto,
        adicionarPassageirosIda,
        adicionarPassageirosVolta,
        selecionarReservasRemarcacao,
        adicionarFormasPagamento,
        adicionarDadosComprador,
        selecionarDestino,
        selecionarOrigem,
        selecionarDataIda,
        selecionarViagem,
        cadastrarReserva,
        pagarPedido,
        remarcarReservas,
        alterarTipoEmissaoPassageiroIda,
        alterarTipoEmissaoPassageiroVolta,
        selecionarDescontoUsuario,
        buscarTiposDocumento,
        limpaViagens,
        informarVendaEmMassa,
        verificarItinerarioAtivoOuInativo,
        selecionarUsuario,
        selecionarAcrescimoPassagemCalculado,
        alterarReservaParaCriada,
        verificarPagamento,
        alterarSituacaoFormaPagamentoReservaCriada,
        usuarioEmpresaHabilitadoPagamentoViaPOS

    })(reduxForm({
    form: 'formReserva',
    enableReinitialize: true,
    destroyOnUnmount: true,
    forceUnregisterOnUnmount: true,
})(PainelVenderPassagem)));
